/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { ThumbsUpFilledIcon, ThumbsUpIcon } from '@coursera/cds-icons';

import type { CmlContent } from 'bundles/cml';
import LikeContent from 'bundles/content-feedback/components/like/LikeContent';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';

import _t from 'i18n!nls/content-feedback';

type Props = {
  selected: boolean;
  tooltipPlacement: string;

  onDeselect: () => void;
  onSelect: (cml: CmlContent) => void;

  comment: any;
  itemFeedbackType: ItemType;
};

const Like: React.FC<Props> = (props) => {
  const { selected } = props;

  return (
    <div
      css={css`
        margin-right: var(--cds-spacing-200);
      `}
      data-testid="like-button"
    >
      <LikeContent {...props}>
        <Button
          size="small"
          variant="ghost"
          aria-pressed={selected}
          icon={selected ? <ThumbsUpFilledIcon color="interactive" /> : <ThumbsUpIcon color="interactive" />}
          iconPosition="before"
        >
          {_t('Like')}
        </Button>
      </LikeContent>
    </div>
  );
};

export default Like;
